import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import StepIndicatorIcon from './StepIndicatorIcon.jsx';

import './StepIndicator.scss';

export default class StepIndicator extends PureComponent {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    duration: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    isDone: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    stepNumber: PropTypes.number.isRequired,
  };

  static defaultProps = {
    currentStep: 0,
    duration: null,
    isActive: false,
    stepNumber: 0,
    isDone: false,
  };

  render() {
    const {currentStep, stepNumber,isActive,isDone, ...props} = this.props;
    return <div className={`step-indicator${isActive ? ' active' : ''}`}>
      <div className="step-indicator-content d-flex flex-nowrap align-items-center">
        <StepIndicatorIcon isDone={isDone} isActive={isActive} stepNumber={stepNumber}/>
        <div className="label">
          <span>{props.label}&nbsp;</span>
          {props.duration ? <span>({props.duration})</span> : ''}
        </div>
      </div>
    </div>;
  }
}
